<template>
  <section class="container hero-section">

    <div class="row"><!-- ./start of row-->
      <!---------start of Website description div--------------->
      <div class="col-md-12 col-lg-6 col-xl-6 mt-4 abstract-container ">
        <div class="top-content">
          <div class="info">
            {{ heroTitle }}
          </div>
          <div class="description">
            {{ heroDescription }}
          </div>
        </div>
        <div class="search-container overflow-lg-hidden">
          <!-- Search Input Field -->
          <div class="input-group  search-input mb-3 mb-lg-0">
            <label><i class="fas fa-search"></i></label>
            <input type="text" class="form-control" :placeholder="$t('search')" aria-label="Search"
              aria-describedby="basic-addon2" />
          </div>

          <div class="px-lg-2">
            <select class="select  mb-3 mb-lg-0" aria-label="select category" v-model="selectedCategory">
              <option selected class="option-with-icon" disabled value="">{{ $t('select-category') }}</option>
              <option value="1">{{ $t('all') }}</option>
              <option value="3">{{ $t('qualification') }}</option>
              <option value="2">{{ $t('development') }}</option>
              <option value="4">{{ $t('diplomas') }}</option>
            </select>
          </div>
          <!-- Search Button -->
          <button type="submit" class="btn btn-search mt-4 mt-lg-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path
                d="M18.375 18.375L14.4497 14.4428M16.625 9.1875C16.625 11.16 15.8414 13.0518 14.4466 14.4466C13.0518 15.8414 11.16 16.625 9.1875 16.625C7.21495 16.625 5.3232 15.8414 3.92839 14.4466C2.53359 13.0518 1.75 11.16 1.75 9.1875C1.75 7.21495 2.53359 5.3232 3.92839 3.92839C5.3232 2.53359 7.21495 1.75 9.1875 1.75C11.16 1.75 13.0518 2.53359 14.4466 3.92839C15.8414 5.3232 16.625 7.21495 16.625 9.1875Z"
                stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>
            {{ $t('search') }}
          </button>
        </div>
        <div class="abstract">
          <img src="../../assets/images/abstract.svg" width="396" height="353" alt="Abstract Image" />
        </div>
      </div>
      <!---------end of Website description div--------------->
      <!---------start of hero image --------------->
      <div class="col-md-12 col-lg-6 col-xl-6 overflow-lg-hidden hero-cut d-none d-lg-block">
        <div class="image-container" :style="{ backgroundImage: `url(${assetsURL}/${backgroundImageUrl})` }">
          <div class="abstract-2">
            <img src="../../assets/images/abstract.svg" width="396" height="353" alt="Abstract Image 2" />
          </div>
        </div>
        <div class="rect">
          <img width="305" height="98" src="../../assets/images/home/rectangular.svg" alt="Rectangular Image" />
        </div>
      </div>
      <!---------start of hero image --------------->
    </div><!-- ./End of row-->

    <!----Video play button-->
    <div class="svg-container d-none d-lg-block" @click="openModal">
      <svg xmlns="http://www.w3.org/2000/svg" width="115" height="115" viewBox="0 0 115 115" fill="none">
        <circle opacity="0.35" cx="57.5" cy="57.5" r="57.5" fill="#2EA2CE" />
        <path
          d="M79.5 54.9019C81.5 56.0566 81.5 58.9434 79.5 60.0981L48.75 77.8516C46.75 79.0063 44.25 77.5629 44.25 75.2535L44.25 39.7465C44.25 37.4371 46.75 35.9937 48.75 37.1484L79.5 54.9019Z"
          fill="white" />
      </svg>
    </div>
    <!---End of Video Play Button-->

    <!--Video Modal start-->
    <Modal ref="thisModal" :modalBodyVideo="true"> </Modal>
    <!--Video Modal end-->
  </section>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import Modal from '../Common/ModalComponent.vue';
// Props
defineProps({
  heroTitle: {
    type: String,
    required: true
  },
  heroDescription: {
    type: String,
    required: true
  },
  backgroundImageUrl: {
    type: String,
    required: true
  },
  heroVideo: {
    type: String,
    required: true
  }
});

// Refs and reactive data
const selectedCategory = ref("");

// Refs to DOM/components
const thisModal = ref(null);

// Store & router & i18n
const store = useStore();
const router = useRouter();
const { locale } = useI18n();

// Assets URL from Vuex
const assetsURL = store.state.AssetUrl;

// Show modal method
function openModal() {
  if (thisModal.value) {
    thisModal.value.show();
  }
}

// Watch category change
watch(selectedCategory, (newVal) => {
  router.push({
    path: `/${locale.value}/courses`,
    query: { category: newVal }
  });
  console.log(newVal);
});
</script>

<style lang="scss" scoped>
.hero-cut {
  z-index: -2;
}

.modal-dialog {
  max-width: 60%;
}

.modal-content {
  background: #fff;
  border: 0;
}

.modal-header {
  border-bottom: 0;
  padding: 8px 0;
}

video {
  width: 100% !important;
}

.modal-body {
  padding-bottom: 15px !important;
  padding-top: 8px;
}

.modal-dialog {
  width: 100%;
}

.btn-close-new {
  font-size: 1.5625rem;
  padding: 0 10px;
  margin: 0;
  border: 0;
  background: transparent;
  color: #00d9ff;
}

.hero-section {
  margin-top: 80px;

  .svg-container {
    position: absolute;
    top: 35%;

    &:lang(en) {
      left: 55%;
      -webkit-transform: scaleX(-1);
      -ms-transform: scaleX(-1);
      transform: scaleX(-1);
    }

    &:lang(ar) {
      left: 44%;
    }

    &:hover {
      cursor: pointer;
    }

    -webkit-transform: translate(-50%, 50%);
    -ms-transform: translate(-50%, 50%);
    transform: translate(-50%, 50%);
  }

  .image-container {
    position: absolute;
    width: 45.1%;
    height: 750px;
    top: 0;

    &:lang(en) {
      -webkit-transform: scaleX(-1);
      -ms-transform: scaleX(-1);
      transform: scaleX(-1);
      right: 0;
    }

    &:lang(ar) {
      left: 0;
    }

    //background-image: url("../../assets/images/home/homeSloder-min.webp");
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 1;
    z-index: -2;
    padding-bottom: 80px;
    overflow: hidden;
  }

  .rect {
    position: absolute;
    height: auto;
    top: 630px;

    &:lang(en) {
      right: 0;
      -webkit-transform: scaleX(-1);
      -ms-transform: scaleX(-1);
      transform: scaleX(-1);
    }

    &:lang(ar) {
      left: 0;
    }

    z-index: -3;
  }

  .rect img {
    width: 100%;
    height: auto;
    display: block;
  }

  .image-container img {
    width: 100%;
    height: auto;
    display: block;
  }

  .title {
    color: #2ea2ce;

    &:lang(en) {
      text-align: left;
    }

    &:lang(ar) {
      text-align: right;
    }

    font-size: 1.5625rem;
    font-weight: 400;
    line-height: 2.4375rem;
  }

  .info {
    color: #000;

    &:lang(en) {
      text-align: left;
    }

    &:lang(ar) {
      text-align: right;
    }

    font-size: 2.5rem;
    font-weight: 700;
    line-height: 3.75rem;
    margin-bottom: 19px;
  }

  .description {
    color: #6c6c6c;

    &:lang(en) {
      text-align: left;
    }

    &:lang(ar) {
      text-align: right;
    }

    font-size: 1.25rem;
    font-weight: 400;
    line-height: 3.125rem;
    padding-top: 10px;
    margin-bottom: 47px;
  }

  /***********start of search container***********************************/
  .search-container {
    border-radius: 20px;
    border: 1px solid #d9d9d9;
    background: #fff;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: .875rem;
    font-weight: 400;
    margin-top: 35px;
    margin-bottom: 35px;
    height: 60px;
    width: 708px;
  }

  .select {
    border: none;
    width: 318px;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    color: #6c6c6c;
    font-family: "Almarai", sans-serif;
    font-size: .875rem;
    cursor: pointer;
    font-weight: 400;
    background-image: url("../../assets/images/radix-icons_dashboard.svg");
    background-repeat: no-repeat;

    background-size: 20px;
    background-color: #fff;

    &:lang(en) {
      padding-left: 35px;
      background-position: 10px center;
      border-left: 1px solid #d9d9d9;

    }

    &:lang(ar) {
      padding-right: 35px;
      background-position: calc(100% - 10px) center;
    }
  }

  .search-input {
    position: relative !important;

    .form-control {
      &:lang(en) {
        border-left: 0 !important;
        margin-left: 40px !important;
      }

      &:lang(ar) {
        margin-right: 40px !important;
        padding-right: 0px !important;
      }
    }

    label {
      position: absolute;
      top: 54%;
      transform: translateY(-50%);

      &:lang(ar) {
        right: 14px;
      }

      &:lang(en) {
        left: 14px;
      }

      color: #aaa;
    }
  }

  .search-input input[type="text"] {

    width: 149px;

    // &:lang(en){
    //   border-right: 1px solid #d9d9d9;
    // }
    &:lang(ar) {
      border-left: 1px solid #d9d9d9;
    }

    // &:lang(en) { 
    //   padding-right: 30px;
    //   margin-left: 20px;
    // }

    // &:lang(ar) {
    //   padding-left: 30px;
    //   margin-right: 0px;
    // }
  }

  .form-control:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .input-group>.form-control {
    position: initial;
  }

  .form-control {
    padding: 0px;
    border: none;
  }

  .input {
    margin: 0px;
    border-bottom-right-radius: 25px;

    &:lang(en) {
      border-top-left-radius: 25px;
    }

    &:lang(ar) {
      border-top-right-radius: 25px;
    }

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
  }

  .btn-search {
    background: #206387;
    color: #fff;
    font-size: 1.25rem;
    font-weight: 700;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 15px;

    &:hover {
      background: transparent;
      border-color: #206387;
      color: #206387;

      svg path {
        stroke: #206387;
      }
    }

    &:lang(en) {
      border-radius: 0 20px 20px 0;
    }

    &:lang(ar) {
      border-radius: 20px 0px 0px 20px;
    }

    svg {
      &:lang(en) {
        padding-right: 5px;
      }

      &:lang(ar) {
        padding-left: 5px;
      }
    }
  }

  /************************************/
  .abstract-container {
    .abstract {
      position: absolute;
      bottom: -150px;
      z-index: -1;

      &:lang(ar) {
        right: -99px;
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      &:lang(en) {
        left: -99px;
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
      }
    }
  }

  .abstract-2 {
    position: absolute;

    &:lang(en) {
      left: 80%;
      -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    }

    &:lang(ar) {
      -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
      right: -10%;
    }

    top: 0%;
    z-index: 10;
    width: 30%;
  }

  /******video styling*********************/
  .modal-body {
    position: relative;
    margin-bottom: -6px;
  }

  .modal-body video {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 936px;
    //height: 500px;
    height: fit-content;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
}

.img-test {
  position: absolute !important;
  top: 58% !important;
  z-index: 10000;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) !important;
  -ms-transform: translate(-50%, -50%) !important;
  transform: translate(-50%, -50%) !important;

  &:hover {
    cursor: pointer;
  }
}

.form-control::placeholder,
select {
  font-size: 1rem !important;
}

/************Responsive****************/
@media screen and (max-width: 576px) {
  // .hero-section .search-input i:lang(ar) {
  //   transform: translate(-11px, 8px);
  // }

  .modal-dialog {
    max-width: 98%;
  }

  .hero-section {
    .abstract-2 {
      &:lang(en) {
        right: 40%;
      }

      &:lang(ar) {
        left: 40%;
      }

      z-index: -1;
    }

    .info {
      font-size: 2.0625rem;
    }

    .image-container {
      width: 100% !important;
      background-size: cover;
      height: 700px;
      background-position: center left;
    }

    .top-content {
      // margin-top: 470px;
    }

    .svg-container {
      position: absolute;
      top: 30% !important;

      /*left: 78% !important;
      &:lang(en) {
        left: 78% !important;
      }
      &:lang() {
        right: 78% !important;
      }*/
      &:lang(en) {
        right: 15% !important;
      }
    }
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .modal-dialog {
    max-width: 95%;
  }

  .hero-section {
    .search-container {
      width: 300px;
    }

    .title {
      padding-top: 80px;
    }

    .image-container {
      background-size: contain;
      min-width: 100%;
      height: 500px;
      background-position: left center;
    }

    .abstract-2 {
      &:lang(en) {
        right: 70% !important;
      }

      &:lang(ar) {
        right: 22%;
      }

      z-index: -1;
    }

    .rect {
      top: 420px;
    }
  }
}

@media (min-width: 768px) and (max-width:992px) {
  .modal-dialog {
    max-width: 80%;
  }

  /*****************************/
  .hero-section {
    .title {
      padding-top: 0px;
    }
  }
}

@media screen and (max-width: 992px) {
  .hero-section .search-input input[type=text] {
    border-left: none;
  }

  .hero-section {
    margin-top: 0;

    .svg-container {
      top: 35%;
    }

    .rect {
      display: none;
    }

    .top-content {
      margin-top: 40px;
    }

    .search-container {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      border: none;
      width: auto;
    }

    .search-input {
      width: 100%;

      /*.fa-search i{
        &::lang(ar){
          -webkit-transform: translate(-6px, 8px);
            -ms-transform: translate(-6px, 8px);
                transform: translate(-6px, 8px);
        }
      }*/
      input[type="text"] {
        &:lang(en) {
           border-right: none;
        }

        &:lang(ar) {
         border-left: none;
        }
      }

      border-radius: 10px;
      padding: 14px 10px;
      border: 1px solid #d9d9d9;
    }

    .select {
      padding: 8px 10px;
      border: 1px solid #d9d9d9;

      &:lang(en) {
        padding-left: 31px;
      }

      &:lang(ar) {
        padding-right: 31px;
      }

      border-radius: 10px;
      margin-top: 1px;
      margin-bottom: 20px;
      width: 100%;
    }

    .btn-search {
      padding: 8px 12px;
      border-radius: 5px !important;
      width: 50%;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      align-self: flex-end;
      margin-bottom: 20px;

      &:lang(en) {
        border-radius: 5px;
      }
    }
  }

  // .hero-section .search-input i:lang(ar) {
  //   transform: translate(0, 5px);
  // }
}

/* Styles for medium devices and up */
@media (min-width: 768px) and (max-width: 992px) {
  .hero-section {
    .image-container {
      width: 100%;
      background-size: contain;
      height: 600px;
    }

    .info {
      margin-bottom: 8px;
    }

    .top-content {
      margin-top: 30px;
      // margin-top: 180px;
      //   .info,
      //   .description {
      //     width: 80%;
      //   }
    }

    .rect {
      top: 470px;
      display: block;
    }

    .svg-container {
      position: absolute;
      top: 40%;

      &:lang(en) {
        right: 26% !important;
      }

      &:lang() {
        left: 26% !important;
      }

      -webkit-transform: translate(-50%, 26%);
      -ms-transform: translate(-50%, 26%);
      transform: translate(-50%, 26%);
    }

    .abstract-2 {
      top: -50px;

      &:lang(en) {
        right: 30% !important;
      }

      &:lang(ar) {
        right: 22%;
      }
    }
  }
}

/*****************************/
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .hero-section {
    .image-container {
      width: 48%;
    }

    .rect {
      top: 470px;
    }

    .select {
      padding: 0 33px !important;
    }
  }
}

/*****************************/
@media (min-width: 1200px) and (max-width: 1439px) {
  .hero-section {
    .image-container {
      position: absolute;
      width: 54%;
      background-size: contain;
    }

    .select {
      padding: 0 33px !important;
    }
  }
}

/*******************************/
@media (min-width: 1600px) {
  .hero-section {
    .image-container {
      position: absolute;
      width: 60%;
      height: 910px;
      background-size: contain;
    }

    .title {
      margin-top: 60px;
    }

    .svg-container {
      top: 42%;

      &:lang(en) {
        right: 39%;
        left: 0;
      }

      &:lang(ar) {
        left: 39%;
      }

      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }

    .rect {
      top: 780px;
    }

    .abstract-container {
      .abstract {
        bottom: 10%;
      }
    }

    .abstract-2 {
      position: absolute;
      width: 28%;
      top: -93px;

      &:lang(en) {
        right: 45%;
      }

      &:lang(ar) {
        right: 10%;
      }
    }
  }

  .modal-dialog {
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
}
</style>